import { SHOW_BANNER, HIDE_BANNER, SET_BANNER_DATA, Banners, BannersState, BannerActionTypes } from './types';

const getBannerDefaultState = () => ({
    data: undefined,
    dismissed: true,
});

export default function overlaysReducer(
    state: BannersState = {
        [Banners.HEADER_BAR_BANNER]: getBannerDefaultState(),
    },
    action: BannerActionTypes
): BannersState {
    switch (action.type) {
        case SHOW_BANNER: {
            if (state[action.identifier] && state[action.identifier].dismissed) {
                return {
                    ...state,
                    [action.identifier]: { ...state[action.identifier], dismissed: false },
                };
            }

            return state;
        }
        case HIDE_BANNER: {
            if (state[action.identifier] && !state[action.identifier].dismissed) {
                return {
                    ...state,
                    [action.identifier]: { ...state[action.identifier], dismissed: true },
                };
            }

            return state;
        }
        case SET_BANNER_DATA: {
            return {
                ...state,
                [action.identifier]: { ...state[action.identifier], data: action.payload, dismissed: false },
            };
        }
        default:
            return state;
    }
}
